const state = {
    screenshotList: [],
    transferEquipmentList: [],
    authorizeObj: {},
    // activationCodeList: []
    // 全局分组列表
    globalAllGroupList: [],
    proxyEquipmentList: [],
    globalProxyIpForm: [],
    // 单视图轮播当前页索引（跨路由保留，跳转返回后恢复卡片位置）
    singleViewSwipeIndex: 0,

}
const mutations = {
    SET_SCREENSHOTLIST: (state, arr) => {
        state.screenshotList = arr
    },
    SET_TEANSFEREQUIPMENTLIST: (state, cover) => {
        state.transferEquipmentList = cover
    },
    SET_AUTHORIZEOBJ: (state, cover) => {
        state.authorizeObj = cover
    },
    SET_GLOBALALLGROUPLIST: (state, cover) => {
        state.globalAllGroupList = cover
    },
    // SET_ACTIVATIONCODELIST: (state, cover) => {
    //     state.activationCodeList = cover
    // },
    SET_PROXYEQUIPMENTLIST: (state, cover) => {
        state.proxyEquipmentList = cover
    },
    SET_GLOBALPROXYIPFORM: (state, cover) => {
        state.globalProxyIpForm = cover
    },
    SET_SINGLEVIEW_SWIPE_INDEX: (state, cover) => {
        state.singleViewSwipeIndex = cover
    },
}
export default {
    // 开启命名空间
    namespaced: true,
    mutations,
    state,
}